module.exports = __webpack_public_path__ + "static/media/12aa.babe4612.jpeg";